import { Modal, Form, Input, Button, message, Row, Col } from "antd";
import { getFirestore, collection, addDoc } from "firebase/firestore";

import { validateSize, validateType } from "./validations";

export const Create = ({ isModalOpen, setIsModalOpen, update }) => {
  const [form] = Form.useForm();

  const db = getFirestore();

  // Create size in firebase
  const handleSubmit = async (values) => {
    await addDoc(collection(db, "sizes"), {
      ...values,
      size:values.size.toUpperCase(),
      status: true,
    })
      .then(() => {
        form.resetFields();
        update();
        message.success(`Talla ${values.size} fue creada`);
        setIsModalOpen(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Modal
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      footer={null}
      title="Informacion de talla"
    >
      <Form
        name="createSize"
        layout="vertical"
        form={form}
        onFinish={handleSubmit}
        autoComplete="off"
        requiredMark
      >
        <Row gutter={16}>
          <Col xs={24} sm={24} md={24} lg={12}>
            <Form.Item
              name="size"
              label="Talla"
              rules={[
                {
                  required: true,
                  message: "Debe ingresar talla",
                  type: "string",
                },
                {
                  validator: validateSize,
                },
              ]}
              hasFeedback
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12}>
            <Form.Item
              name="type"
              label="Tipo"
              rules={[
                {
                  required: true,
                  message: "Debe ingresar tipo",
                },
                {
                  validator: validateType,
                },
              ]}
              hasFeedback
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item className="button-form footer-btn-modal create-form-btns">
          <Button onClick={() => setIsModalOpen(false)} size="large">
            Cancelar
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            className="button-right"
          >
            Crear
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};
